<script lang="ts" setup>
import { computed, PropType, ref } from "vue";
import { TirPmTooltipElementPlacementEnum } from "./enums";
import {
  PopoverColorEnum,
  PopoverPositionEnum,
  TirPmPopover,
} from "tir-pm-popover";

const props = defineProps({
  /**Позиция */
  position: {
    type: String as PropType<TirPmTooltipElementPlacementEnum>,
    default: TirPmTooltipElementPlacementEnum.Top,
  },
  /**Скрывать треугольник */
  isHideTriangle: {
    type: Boolean,
    default: false,
  },
  /**Классы компонента */
  classes: { type: String },
  /**Ширина */
  width: { type: String, default: "10.313rem" },
  /**Задержку при открытии тултипа */
  openDelay: { type: Number, default: 150 },
  /**Задержка при закрытии тултипа */
  closeDelay: { type: Number, default: 50 },
  /**Неактивность */
  isDisabled: { type: Boolean, default: false },
  /**Неактивность телепорта */
  isNoTeleport: { type: Boolean, default: false },
});

/**Ссылка на компоненте popover */
const $popover = ref<InstanceType<typeof TirPmPopover>>();

/**Позиция поповера */
const popoverPosition = computed(() => {
  switch (props.position) {
    case TirPmTooltipElementPlacementEnum.Top:
      return PopoverPositionEnum.Top;
    case TirPmTooltipElementPlacementEnum.Right:
      return PopoverPositionEnum.Right;
    case TirPmTooltipElementPlacementEnum.Bottom:
      return PopoverPositionEnum.Bottom;
    case TirPmTooltipElementPlacementEnum.Left:
      return PopoverPositionEnum.Left;
  }
});
/**Классы поповера */
const popoverClasses = computed(() =>
  props.classes
    ? `${props.classes} tir-pm-tooltip-element__popover`
    : "tir-pm-tooltip-element__popover"
);

/**Экспорт методов управления видимости компонента popover */
defineExpose({
  open: () => $popover.value?.open(),
  close: () => $popover.value?.close(),
});
</script>

<template>
  <TirPmPopover
    ref="$popover"
    :is-tooltip="true"
    :position="popoverPosition"
    :color="PopoverColorEnum.Black"
    :is-hide-triangle="isHideTriangle"
    :classes="popoverClasses"
    :width="width"
    :is-disabled="isDisabled"
    :is-no-teleport="isNoTeleport"
    :tooltip-open-delay="openDelay"
    :tooltip-close-delay="closeDelay"
  >
    <slot />
    <template #content>
      <div class="tir-pm-tooltip-element__content">
        <slot name="content" />
      </div>
    </template>
  </TirPmPopover>
</template>

<style lang="scss" scoped>
.tir-pm-tooltip-element {
  &__content {
    padding: var(--tir-pm-tooltip__padding);
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1rem;
  }
}
</style>

<style lang="scss">
.tir-pm-tooltip-element__popover {
  --tir-popover-tr: 0.25rem;
}
</style>
